<template>
  <h3
    :class="
      cn('tw:text-xl tw:font-semibold tw:leading-none tw:tracking-tight tw:mb-0', props.class)
    "
  >
    <slot />
  </h3>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
